import React, { createContext } from 'react';

export interface AudioProps {
  audioSrc: string;
  setAudioSrc: React.Dispatch<React.SetStateAction<string>>;
  isPlayed: boolean;
  setIsPlayed: React.Dispatch<React.SetStateAction<boolean>>;
  audioRef?: React.RefObject<HTMLAudioElement>;
};

const contextDefault: AudioProps = {
  audioSrc: '',
  setAudioSrc: () => {},
  isPlayed: false,
  setIsPlayed: () => {},
};

const AudioContext = createContext<AudioProps>(contextDefault);

export default AudioContext;